"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerOpportunityRadius = void 0;
const typeorm_1 = require("typeorm/browser");
const data_ui_1 = require("../data-ui");
const layouts_1 = require("../data-ui/layouts");
const contact_profile_enum_1 = require("./contact-profile-enum");
const opportunity_1 = require("./opportunity");
const partner_1 = require("./partner");
let PartnerOpportunityRadius = class PartnerOpportunityRadius {
};
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
        name: 'id',
    }),
    __metadata("design:type", String)
], PartnerOpportunityRadius.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)(() => partner_1.Partner),
    __metadata("design:type", partner_1.Partner)
], PartnerOpportunityRadius.prototype, "partner", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)(() => opportunity_1.Opportunity),
    __metadata("design:type", opportunity_1.Opportunity)
], PartnerOpportunityRadius.prototype, "opportunity", void 0);
__decorate([
    (0, typeorm_1.Column)('int'),
    __metadata("design:type", Number)
], PartnerOpportunityRadius.prototype, "radius", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        name: 'bypass_local_prio_delay',
        default: false,
        nullable: false,
    }),
    __metadata("design:type", Boolean)
], PartnerOpportunityRadius.prototype, "bypassLocalPrioDelay", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        name: 'prioritized',
        default: false,
        nullable: false,
    }),
    __metadata("design:type", Boolean)
], PartnerOpportunityRadius.prototype, "prioritized", void 0);
PartnerOpportunityRadius = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.EXTERNAL_DATA_MAINTAINER,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.EXTERNAL_TAX_OFFICE,
            contact_profile_enum_1.ContactProfileEnum.LOGIN_AS_USER,
            contact_profile_enum_1.ContactProfileEnum.TECHNICAL_SUPPORT,
        ],
        write: [
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
        ],
    }),
    data_ui_1.DataUi.Name({
        name: 'Partner Opportunity Radius',
        nameProperties: ['id'],
    }),
    data_ui_1.DataUi.DefaultLayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Entity)('partner_opportunity_radius', { schema: 'public' })
], PartnerOpportunityRadius);
exports.PartnerOpportunityRadius = PartnerOpportunityRadius;
//# sourceMappingURL=partner-opportunity-radius.js.map